import { html } from "htm/preact";
import { useState, useEffect } from "preact/hooks";
import { InnerContainer } from "../inner-container";
import { UnderlineLink } from "../underline-link";

function chunk(array, size) {
  if (!array) return [];
  const firstChunk = array.slice(0, size); // create the first chunk of the given array
  if (!firstChunk.length) {
    return array; // this is the base case to terminal the recursive
  }
  return [firstChunk].concat(chunk(array.slice(size, array.length), size));
}

export const NearYouSection = () => {
  let width = (typeof window !== "undefined" && window.innerWidth) || 0;
  const [numSlides, setNumSlides] = useState(3);
  if (typeof window !== "undefined") {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
      window.addEventListener("resize", () => setWidth(window.innerWidth));
      if (width >= 1024) {
        setNumSlides(3);
      } else if (width <= 1024 && width >= 600) {
        setNumSlides(2);
      } else {
        setNumSlides(1);
      }
    }, [width]);
  }
  const [activeSlide, setActiveSlide] = useState(0);
  const cards = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  const slides = chunk(cards, numSlides);
  return html`
    <${InnerContainer}>
      <h2 class="text-4xl font-semibold mb-5">Most popular restaurants near you</h2>
      <${UnderlineLink} href="#">View all restaurants<//>
      <div class="w-full h-full mt-10 relative overflow-hidden">
        <div class="flex transition duration-300 ease-in-out" style="transform: translateX(-${activeSlide * 100}%)">
          ${slides.map(
            (slideArr, index) => html`
              <div class="flex-shrink-0 w-full grid grid-cols-${numSlides} gap-10 md:px-5" key="${index}">
                ${slideArr.map((card, index) => html` <${CarouselCard} className="" index="${card}" key="{index}" /> `)}
              </div>
            `
          )}
        </div>
      </div>
      <div class="flex items-center mt-10 w-full justify-end">
        <span class="mx-3">
          ${activeSlide + 1}/${slides.length}
        </span>
        <button
          href="#near-slide-0"
          class="mx-2 button button-light button-lg"
          onClick="${() => setActiveSlide(activeSlide === 0 ? activeSlide : activeSlide - 1)}"
        >
          ${"<"}
        </button>
        <button
          href="#near-slide-2"
          class="ml-2 button button-light button-lg"
          onClick="${() => setActiveSlide(activeSlide === slides.length - 1 ? activeSlide : activeSlide + 1)}"
        >
          ${">"}
        </button>
      </div>
    <//>
  `;
};

const CarouselCard = ({ className, index }) => {
  return html`
    <a href="#" class="flex flex-col group link-dim-none ${className}">
      <div class="aspect-ratio-16-9">
        <div class="aspect-ratio-box-inside">
          <img
            src="https://d1ralsognjng37.cloudfront.net/0d38a7db-6888-44ee-868a-9199794dfbf6.jpeg"
            alt=""
            class="w-full h-full object-cover transform group-hover:scale-125 transition duration-100 ease-linear"
          />
        </div>
      </div>
      <div class="p-5 flex flex-col items-start">
        <h3 class="text-2xl font-medium">Little Spring Rolls and Bowls ${index}</h3>
        <span class="text-primary-500 text-xs font-mono mt-5">$ • Japanese • Sushi • Rice-bowls</span>
        <span class="bg-primary-100 text-primary-700 px-2 py-1 text-xs font-mono mt-1">Opens at 10:30 AM</span>
      </div>
    </a>
  `;
};
